import { Link } from '@mui/material'

import DateTimeDisplay from '../../components/DateTimeDisplay'
import EntityListTemplate from '../../templates/EntityListTemplate'
import { getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid'

const UsersPage = () => {
  const stringOperators = getGridStringOperators().filter(
    (operator) =>
      operator.value === 'contains' ||
      operator.value === 'equals' ||
      operator.value === 'startsWith',
  )

  const handleLinkClick = (event) => {
    event.stopPropagation()
  }

  const columns = [
    {
      field: 'email',
      headerName: 'Email',
      type: 'string',
      sortable: true,
      filterable: true,
      filterOperators: stringOperators,
      width: 200,
      flex: 1,
    },

    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      width: 200,
      flex: 1,
    },
    {
      field: 'organization',
      headerName: 'Organization',
      type: 'string',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      width: 200,
      flex: 1,
      renderCell: (params) => {
        return params.value ? (
          <Link
            href={`/organizations/${params.value.uuid}`}
            onClick={handleLinkClick}
          >
            {params.value.name}
          </Link>
        ) : (
          'N/A'
        )
      },
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      type: 'string',
      sortable: true,
      filterable: false,
      editable: false,
      width: 180,
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.row.createdAt)
        return <DateTimeDisplay date={date} showTime={true} />
      },
    },
  ]

  return (
    <EntityListTemplate
      entityName="users"
      columns={columns}
      title="Users"
      defaultSort={[{ field: 'createdAt', sort: 'desc' }]}
      tableProps={{
        isRowSelectable: (params) => !params.row.deleted,
      }}
    />
  )
}

export default UsersPage
